/** Omit filter when none or all options are selected (= show all). */
export function buildMultiSelectFilterParam(
  selected: string[],
  allOptionValues: string[],
): string | undefined {
  if (allOptionValues.length === 0) {
    return undefined;
  }
  if (selected.length === 0 || selected.length >= allOptionValues.length) {
    return undefined;
  }
  return selected.join(",");
}

export function parseMultiSelectFilterParam(value?: string): string[] {
  if (!value) {
    return [];
  }
  return value
    .split(",")
    .map(item => item.trim())
    .filter(Boolean);
}
